import { Table, ActionIcon, Tooltip, Badge } from '@mantine/core';
import { IconEdit } from '@tabler/icons-react';

interface WellBeingQuestionsListProps {
	questions: any[];
	onEdit: (question: any) => void;
}

export function WellBeingQuestionsList({ questions, onEdit }: WellBeingQuestionsListProps) {
	if (questions.length === 0) {
		return <div>No questions found</div>;
	}

	const rows = questions.map((question) => (
		<Table.Tr key={question.id}>
			<Table.Td>
				<Badge variant="light" color="blue">
					{question.sortOrder}
				</Badge>
			</Table.Td>
			<Table.Td>{question.questionKey}</Table.Td>
			<Table.Td style={{ maxWidth: 400 }}>{question.text}</Table.Td>
			<Table.Td>
				<Tooltip label="Edit Translations">
					<ActionIcon variant="subtle" color="#1A4D66" onClick={() => onEdit(question)}>
						<IconEdit size={16} />
					</ActionIcon>
				</Tooltip>
			</Table.Td>
		</Table.Tr>
	));

	return (
		<Table highlightOnHover>
			<Table.Thead>
				<Table.Tr>
					<Table.Th>Order</Table.Th>
					<Table.Th>Question Key</Table.Th>
					<Table.Th>Text (English)</Table.Th>
					<Table.Th>Actions</Table.Th>
				</Table.Tr>
			</Table.Thead>
			<Table.Tbody>{rows}</Table.Tbody>
		</Table>
	);
}
